import React from "react";

const Projects = () => {
  return (
    <section>
      <figure>
        <svg
          enableBackground="new 0 0 54 54"
          version="1.1"
          viewBox="0 0 54 54"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m27 8c-9.374 0-17 7.626-17 17 0 7.112 4.391 13.412 11 15.9v9.1c0 0.553 0.447 1 1 1h1v2c0 0.553 0.447 1 1 1h6c0.553 0 1-0.447 1-1v-2h1c0.553 0 1-0.447 1-1v-9.1c6.609-2.488 11-8.788 11-15.9 0-9.374-7.626-17-17-17zm3 41c-0.553 0-1 0.447-1 1v2h-4v-2c0-0.553-0.447-1-1-1h-1v-5h8v5h-1zm1.688-9.758c-0.411 0.135-0.688 0.519-0.688 0.95v1.808h-8v-1.808c0-0.432-0.277-0.815-0.688-0.95-6.167-2.028-10.312-7.752-10.312-14.242 0-8.271 6.729-15 15-15s15 6.729 15 15c0 6.49-4.145 12.214-10.312 14.242z" />
          <path d="m27 6c0.553 0 1-0.447 1-1v-4c0-0.553-0.447-1-1-1s-1 0.447-1 1v4c0 0.553 0.447 1 1 1z" />
          <path d="m51 24h-4c-0.553 0-1 0.447-1 1s0.447 1 1 1h4c0.553 0 1-0.447 1-1s-0.447-1-1-1z" />
          <path d="m7 24h-4c-0.553 0-1 0.447-1 1s0.447 1 1 1h4c0.553 0 1-0.447 1-1s-0.447-1-1-1z" />
          <path d="m43.264 7.322l-2.828 2.828c-0.391 0.391-0.391 1.023 0 1.414 0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293l2.828-2.828c0.391-0.391 0.391-1.023 0-1.414s-1.024-0.39-1.414 0z" />
          <path d="m12.15 38.436l-2.828 2.828c-0.391 0.391-0.391 1.023 0 1.414 0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293l2.828-2.828c0.391-0.391 0.391-1.023 0-1.414s-1.023-0.391-1.414 0z" />
          <path d="m41.85 38.436c-0.391-0.391-1.023-0.391-1.414 0s-0.391 1.023 0 1.414l2.828 2.828c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.391 0.391-1.023 0-1.414l-2.828-2.828z" />
          <path d="m12.15 11.564c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.391 0.391-1.023 0-1.414l-2.828-2.828c-0.391-0.391-1.023-0.391-1.414 0s-0.391 1.023 0 1.414l2.828 2.828z" />
          <path d="m27 13c-6.617 0-12 5.383-12 12 0 0.553 0.447 1 1 1s1-0.447 1-1c0-5.514 4.486-10 10-10 0.553 0 1-0.447 1-1s-0.447-1-1-1z" />
        </svg>
      </figure>
      <div>
        <h4>Some of My Projects</h4>
        <article>
          <ul>
            <li>
              <a
                href="https://github.com/iAli22/Freelancers_App"
                target="_black"
              >
                Qaff platform / code Repo
              </a>
              : React.js
            </li>

            <li>
              <a href="https://al-jalees.com/en" target="_black">
                al-jalees
              </a>
              : React.js
            </li>

            <li>
              <a href="https://j-eman.net/" target="_black">
                j-eman
              </a>
              : React.js
            </li>

            <li>
              <a href="https://ha-law.sa/en" target="_black">
                Harasani group
              </a>
              : React.js
            </li>
            <li>
              <a href="https://www.hijazlfc.com/en" target="_black">
                hijaz Law Firm
              </a>
              : React.js
            </li>

            <li>
              <a href="https://othaimeenfoundation.slsal.co/en" target="_black">
                Othaimeen foundation
              </a>
              : React.js
            </li>

            <li>
              <a href="https://noorinternational.net/en" target="_black">
                Noor international
              </a>
              : jQuery
            </li>

            <li>
              <a href="https://visit.guide/en" target="_black">
                Visit.guide
              </a>
            </li>

            <li>
              <a
                href="https://github.com/iAli22/FSSR_Enrollment"
                target="_black"
              >
                FSSR Enrollment System / code Repo
              </a>
              : React.js
            </li>

            <li>
              <a href="https://adalagroup.com/en" target="_black">
                Adala group
              </a>
              : React.js
            </li>

            <li>
              <a href="https://aljendy.law/en" target="_black">
                Aljendy Law Firm
              </a>
              : React.js
            </li>

            <li>
              <a href="https://clfg.slsal.co/en" target="_black">
                Center for Local Governance
              </a>
              : React.js
            </li>
            <li>
              <a href="https://www.masaratcenter.com/en" target="_black">
                Masarat Center
              </a>
              : React.js
            </li>

            <li>
              <a href="http://etqaaan.com/" target="_black">
                Etqann
              </a>
              : React.js
            </li>

            <li>
              <a href="https://slsal.co" target="_black">
                Slsal CMS
              </a>
              : Vue.js
            </li>

            <li>
              <a href="https://suraihi.com/" target="_black">
                Suraihi Law Firm
              </a>
              : Vue.js
            </li>

            <li>
              <a href="https://www.tafseer.info/en" target="_black">
                Tafseer Center
              </a>
              : Vue.js
            </li>

            <li>
              <a href="https://m-fryan.com/ " target="_black">
                Alfryan Personal Site
              </a>
              : Vue.js
            </li>

            <li>
              <a href="https://saais.org.sa" target="_black">
                Saudi Asthma and Immunology Society
              </a>
              : jQuery
            </li>

            <li>
              <a href="https://almehrej.co/" target="_black">
                Almehrej Law Firm
              </a>
              : jQuery
            </li>

            <li>
              <a href="http://bsaer.net/" target="_black">
                Bsaer
              </a>
              : jQuery
            </li>

            <li>
              <a href="https://mokhtasr.net/" target="_black">
                Mokhtasr
              </a>
              : jQuery
            </li>
          </ul>
        </article>
      </div>
    </section>
  );
};

export default Projects;
